
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nutrition/[postHandle]",
      function () {
        return require("private-next-pages/nutrition/[postHandle].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nutrition/[postHandle]"])
      });
    }
  